import { FormControl, FormGroup } from '@angular/forms';

export enum AddEvaluationDropdownStep {
  Selection,
  AddEvaluation,
}

export type AddEvaluationDropdownForm = FormGroup<{
  offerId: FormControl<number | null>;
  templateId: FormControl<number | null>;
}>;

export interface AddEvaluationSubmit {
  offerId?: number;
  talentPoolId?: number;
  templateId: number;
}
